import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Button } from '../Button';

interface SidebarItem {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  path: string;
  selectedIcon?: React.ComponentType<{ className?: string }>;
}

export const Sidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const sidebarItems: SidebarItem[] = [
    {
      icon: SVGAssets.FavoritesIcon,
      label: t('favorites'),
      path: '/favorites',
      selectedIcon: SVGAssets.FavoritesIcon
    },
    {
      icon: SVGAssets.PhotosIcon,
      label: t('photos'),
      path: '/photos',
      selectedIcon: SVGAssets.PhotoWhite
    },
    {
      icon: SVGAssets.PeopleIcon,
      label: t('people'),
      path: '/people',
      selectedIcon: SVGAssets.PeopleWhite
    },
    {
      icon: SVGAssets.MemoriesIcon,
      label: t('memories'),
      path: '/memories',
      selectedIcon: SVGAssets.MemoryWhite
    },
    {
      icon: SVGAssets.FamilyTreeIcon,
      label: t('familyTree'),
      path: '/family-tree',
      selectedIcon: SVGAssets.TreeWhite
    },
    {
      icon: SVGAssets.RecipesIcon,
      label: t('recipes'),
      path: '/recipes',
      selectedIcon: SVGAssets.RecipieWhite
    },
    {
      icon: SVGAssets.Shares,
      label: t('sharing'),
      path: '/sharing',
      selectedIcon: SVGAssets.ShareWhite
    },
    {
      icon: SVGAssets.StorageIcon,
      label: t('storage'),
      path: '/storage',
      selectedIcon: SVGAssets.StorageWhite
    },
    {
      icon: SVGAssets.TrashIcon,
      label: t('trash'),
      path: '/trash',
      selectedIcon: SVGAssets.TrashWhite
    }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex-shrink-0 overflow-y-auto">
      <nav className="p-4 space-y-1">
        {sidebarItems.map((item, index) => {
          const active = isActive(item.path);
          const Icon =
            active && item.selectedIcon ? item.selectedIcon : item.icon;

          return (
            <Button
              btnStyle="link"
              key={index}
              href={item.path}
              className={`
                w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors
                ${
                  active
                    ? 'bg-[#49712B] text-white font-medium'
                    : 'text-[#505050] hover:bg-[#ebe5e5]'
                }
              `}>
              <Icon
                className={`w-5 h-5 ${active ? 'text-white' : 'text-[#505050]'}`}
              />
              <span
                className={`text-sm ${active ? 'text-white' : 'text-[#505050]'}`}>
                {item.label}
              </span>
            </Button>
          );
        })}
      </nav>
    </aside>
  );
};
